'use client';

import {
  useEffect,
  useState
} from 'react';

// Animates from 0 to `end` over `duration`ms via requestAnimationFrame, only
// once `active` flips true - callers pair this with useScrollReveal so stat
// counters don't run off-screen before a visitor ever sees them.
export function useCountUp(end: number, active: boolean, duration = 1500) {

  const [ count, setCount ] = useState(0);

  useEffect(() => {

    if (!active) {

      return;
    }

    let startTime: number | null = null;
    let raf: number;

    const animate = (timestamp: number) => {

      if (startTime === null) {

        startTime = timestamp;
      }

      const progress = Math.min((timestamp - startTime) / duration, 1);

      setCount(Math.floor(progress * end));

      if (progress < 1) {

        raf = requestAnimationFrame(animate);
      }
    };

    raf = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(raf);
  }, [ active, end, duration ]);

  return count;
}
